module.exports = __webpack_public_path__ + "img/enterprise.b20d1c99.png";